import { get, post, put, deleteRequest } from "utils/api";

// Total System Usage API
export const getTotalSystemUsage = async params => {
  const TotalSystemSpentResponse = await get("/admin/smsExpense", params);
  return TotalSystemSpentResponse.data;
};

// Total System Purchase API
export const getTotalSystemPurchase = async params => {
  const TotalSystemPurchaseResponse = await get(`/admin/purchase`, params);
  return TotalSystemPurchaseResponse.data;
};

// Users Expense List API
export const getUsersExpense = async params => {
  const UsersExpenseResponse = await get("/admin/usage", params);
  return UsersExpenseResponse.data;
};

// Users Tokens List API
export const getUsersTokens = async params => {
  const UsersTokensResponse = await get("/admin/view-token", params);
  return UsersTokensResponse.data;
};

// provider routes page apis
export const getProviderRoutes = async params => {
  const response = await get("/admin/sender-provider", params);
  return response.data.data;
};

export const deleteProviderRoutes = async (params, id) => {
  const response = await deleteRequest(`/admin/sender-provider/${id}`, params);
  return response.data;
};

export const mapProviderRoute = async params => {
  const response = await post(`/admin/sender-provider`, params);
  return response.data;
};

export const updateProviderMapping = async (id, params) => {
  const response = await put(`/admin/sender-provider/${id}`, params);
  return response.data;
};

// provider SQS apis
export const getProviderSQS = async params => {
  const response = await get("/admin/provider-meta", params);
  return response.data.data;
};

export const deleteProviderSQS = async (params, id) => {
  const response = await deleteRequest(`/admin/provider-meta/${id}`, params);
  return response.data;
};

export const mapProviderSQS = async params => {
  const response = await post(`/admin/provider-meta`, params);
  return response.data;
};

export const updateProviderSQS = async (id, params) => {
  const response = await put(`/admin/provider-meta/${id}`, params);
  return response.data;
};

export const getAllProviders = async params => {
  const response = await get(`/admin/provider`, params);
  return response.data.data;
};

export const getDefaultProvider = async params => {
  const response = await get(`/admin/default-provider`, params);
  return response.data;
};

export const setDefaultProvider = async params => {
  const response = await post(`/admin/default-provider`, params);
  return response.data;
};

// API function for user purchase orders
export const getUserPurchaseOrders = async (params = {}) => {
  const response = await get(`/admin/userPurchaseOrder`, params);
  return response.data;
};

// API function for dedicated numbers
export const getDedicatedNumbers = async params => {
  const response = await get(`/admin/dedicatedNumbers`, params);
  return response.data;
};

export const fetchDedicatedNumbers = async params => {
  const response = await get(`/admin/dedicated-number`, params);
  return response.data;
};

// API functions for invoice creation
export const getInvoiceData = async ({ month, year, userId, medium, invoiceMethod }) => {
  const queryParams = new URLSearchParams({
    month: String(month),
    year: String(year),
    userId,
    medium,
    invoiceMethod
  }).toString();

  const response = await post(`/admin/createInvoice?${queryParams}`);
  return response.data;
};

export const sendCreateInvoiceWithNumbers = async (params = {}) => {
  const queryParams = new URLSearchParams({
    month: String(params.month),
    year: String(params.year),
    userId: params.userId,
    medium: params.medium
  }).toString();

  // Pass all form values in payload
  const payload = {
    numbers: params.numbers,
    totalSms: Number(params.totalSms),
    totalMms: Number(params.totalMms),
    perSmsRate: Number(params.perSmsRate),
    perMmsRate: Number(params.perMmsRate),
    dedicatedAmount: Number(params.dedicatedAmount),
    totalAmount: Number(params.totalAmount)
  };

  const response = await post(`/admin/submitInvoice?${queryParams}`, payload);

  return response.data;
};

export const getUserInvoices = async (userId, params = {}) => {
  const response = await get(`/admin/getInvoices/${userId}`, params);
  return response.data;
};
